import {useState} from 'react';
import {Modal} from 'react-bootstrap';
import {createPortal} from 'react-dom';
import usePortal from '../lib/usePortal';
import {usePortalContext} from '../lib/context/portalContext';

const PortalModal = ({ id, title, children }, props) => {
  const target = usePortal(id);
  const {togglePortal, isShowing} = usePortalContext();
  
  const nodes = Array.isArray(children) ? children.filter(child => {
    return child !== null && child !== undefined && child !== false;
  }) : [children];

  return createPortal(
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={isShowing}
      onHide={togglePortal}
      animation={false}
      className="modal-white"
    >
      {nodes?.map((child, i) => child )}
    </Modal>,
    target
  );
};

export default PortalModal;
